import React from "react"

function Heading2({ heading, subheading, darkBgFlag = false }) {
  return (
    <div className="container pb-3">
      <div className="serviceHeading fs-1 text-purple d-flex align-items-center lh-md">
        <div
          className="me-3"
          style={{
            width: "30px",
            height: "3.5px",
            backgroundColor: darkBgFlag ? "#9E5DF7" : "#5403bd",
            borderRadius: "3px",
            opacity: "0.9",
          }}
        ></div>
        <div
          style={{
            letterSpacing: "3px",
            color: darkBgFlag ? "#9E5DF7" : "inherit",
          }}
        >
          {heading}
        </div>
      </div>
      <div
        className="serviceSubHeading text-uppercase text-gray d-flex align-items-center lh-1"
        style={{ marginLeft: "33px" }}
      >
        <div className="me-3 invisible"></div>
        <div
          style={{
            color: darkBgFlag ? "rgba(255, 255, 255, 0.7)" : "inherit",
          }}
        >
          {subheading}
        </div>
      </div>
    </div>
  )
}

export default Heading2
